export default __webpack_public_path__ + "static/media/remove-spice-rack.05765300.svg";